import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Badge,
  Table,
  FormGroup,
  Label,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import Spinner from '../Spinner';
import config from '@config';
import { GUEST_REPORTS, REPORTS_MULTI_DELETE, RESEND_REPORT, UPDATE_REPORT_TITLE } from '@api';
import { Icon } from '@assets';
import SendDraftReport from '../../modules/Property/Properties/SendDraftReport';
import SidebarRight from '../SidebarRight';
import Select from 'react-select';
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useAsyncDebounce,
  useRowSelect,
} from 'react-table';
import moment from 'moment';

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input
          type='checkbox'
          className='custom-checkbox'
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

function GlobalFilter({
  preGlobalFilteredRows: _preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const [value, setValue] = React.useState(globalFilter);

  const onChange = useAsyncDebounce((val) => {
    setGlobalFilter(val || undefined);
  }, 200);

  return (
    <div className='search-bar d-inline-block inline-block w-100'>
      <FormGroup className='mb-0 w-auto d-inline-block'>
        <div className='d-flex align-items-center w-100'>
          <Label
            for='report-search'
            className='mb-0 w-auto d-inline-flex align-items-center mr-2'
          >
            <Icon icon='search' />
          </Label>
          <input
            id='report-search'
            value={value || ''}
            onChange={(e) => {
              setValue(e.target.value);
              onChange(e.target.value);
            }}
            placeholder='Search by keywords'
            className='w-100'
          />
        </div>
      </FormGroup>
    </div>
  );
}

const mobileStyles = {
  filterContainer: {
    marginBottom: '16px',
    padding: '12px',
    borderRadius: '16px',
    background: '#f8fafc',
    boxShadow: '0 6px 18px rgba(15, 34, 58, 0.08)',
  },
  filterHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  filterRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '13px',
    color: '#475569',
  },
  filterLabel: {
    fontWeight: 600,
  },
  mobileActionsWrapper: {
    display: 'flex',
    gap: '12px',
    marginTop: '8px',
    flexWrap: 'wrap',
  },
  actionButton: {
    flex: '1 1 140px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 14px',
    borderRadius: '12px',
    boxShadow: '0 6px 16px rgba(15, 34, 58, 0.12)',
    fontSize: '0.9rem',
    fontWeight: 600,
  },
  listWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    paddingBottom: '72px',
  },
  card: {
    background: '#ffffff',
    borderRadius: '16px',
    padding: '16px',
    boxShadow: '0 10px 28px rgba(15, 34, 58, 0.1)',
    border: '1px solid #eef2f7',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: '1 1 auto',
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
  primaryName: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#1f2933',
  },
  badge: {
    fontSize: '12px',
    fontWeight: 600,
    padding: '3px 8px',
    borderRadius: '999px',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  subtitle: {
    fontSize: '13px',
    color: '#64748b',
  },
  timeAgo: {
    fontSize: '12px',
    color: '#94a3b8',
  },
  detailSection: {
    marginTop: '12px',
    display: 'grid',
    rowGap: '8px',
  },
  detailText: {
    fontSize: '13px',
    color: '#334155',
    lineHeight: 1.45,
  },
  linkText: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#2563eb',
  },
  actionRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '16px',
  },
  primaryButton: {
    flex: '1 1 48%',
    borderRadius: '12px',
    fontSize: '13px',
    fontWeight: 600,
    padding: '10px 12px',
  },
  secondaryButton: {
    flex: '1 1 48%',
    borderRadius: '12px',
    fontSize: '13px',
    fontWeight: 600,
    padding: '10px 12px',
  },
};

const formatRelativeTime = (dateString) => {
  if (!dateString) return '';
  const diff = moment(dateString);
  if (!diff.isValid()) return '';
  return diff.fromNow();
};
// import {
//   useTable,
//   useSortBy,
//   usePagination,
//   useGlobalFilter,
//   useAsyncDebounce,
//   useRowSelect,
// } from 'react-table';
// import moment from 'moment';

export default function MyReport(props) {

  const [reports, setReports] = useState([]);
  const [data, setData] = useState('loading');
  const [isCheckedId, setIsCheckedId] = useState([]);
  const [allDeleteModal, setAllDeleteModal] = useState(false);
  const [isChecked, setIsChecked] = useState([]);
  const [isProgress, setIsProgress] = useState(false);
  const [resendMailId, setResendMailId] = useState(null);
  const [resendModal, setResendModal] = useState(false);

  const {
    data: guestReportData,
    loading: reportsLoading,
    error: reportsError,
    refetch: refetchGuestReports,
  } = useQuery(GUEST_REPORTS, {
    onCompleted: (data) => {},
    onError: (e) => {
      console.log(e);
    },
  });

  const history = useHistory();

  useEffect(() => {
    if (guestReportData) {
      if (guestReportData.reports.totalCount === 0) {
        setData('noData');
      } else {
        setData('data');
        setReports(guestReportData.reports.edges);
      }
    }
  }, [guestReportData]);

  const [reportResendMail, { data: reportResendData }] = useMutation(
    RESEND_REPORT,
    {
      onCompleted: (data) => {
        if (data.resendReport.errors === null) {
          setResendModal(!resendModal);
          toast(data.resendReport.message, { type: 'success' });
          setIsProgress(false);
        } else {
          toast(data.resendReport.message, { type: 'error' });
        }
      },
      onError: (e) => {
        console.log(e);
        toast(e, { type: 'error' });
      }
    }
  );

  const [reportMultiDelete] = useMutation(REPORTS_MULTI_DELETE, {
    onCompleted: (data) => {
      setAllDeleteModal(!allDeleteModal);
      toast(data.reportMultiDelete.message, { type: 'success' });
      setIsProgress(false);
    },
    refetchQueries: [GUEST_REPORTS],
    onError: (e) => {
      console.log(e);
    },
  });

  const [updateReportTitle] = useMutation(UPDATE_REPORT_TITLE, {
    onCompleted: (data) => {
      toast(data.updateReportTitle.message, { type: 'success' });
    },
    onError: (e) => {
      console.log(e);
    },
  });

  const resendMail = (id = null) => {
    setResendMailId(parseInt(id));
    setResendModal(true);
  };

  const handleResendMail = async () => {
    setIsProgress(true);
    await reportResendMail({ variables: { id: resendMailId } });
  };

  const onResendPopup = () => {
    if (resendMailId) {
      setResendModal(!resendModal);
    }
  };

  const handleDeleteAll = async () => {
    setIsProgress(true);
    await reportMultiDelete({
      variables: {
        ids: isCheckedId,
      },
    });
  };

  const handleSingleDelete = (id) => {
    setIsCheckedId([parseInt(id)]);
    setAllDeleteModal(true);
  };

  const handleTitleInput = (e, reportId) => {
    updateReportTitle({
      variables: {
        id: Number(reportId),
        title: e,
      },
    });
  };

  useEffect(() => {
    setIsCheckedId([]);
    var isSelectedIds = [];
    isChecked.map(function (key, index) {
      if (key.original) {
        isSelectedIds.push(parseInt(key.original.node.id));
      }
    });
    setIsCheckedId(isSelectedIds);
  }, [isChecked]);


  const [sidebarWidth, setSidebarWidth] = useState('1150px');
  const [sidebarState, setSidebarState] = useState(false);
  const [showInSidebar, setShowInSidebar] = useState('');
  const [reportId, setReportId] = useState([]);
  const [draftTitle, setDraftTitle] = useState('');

  const showSendList = (
    <SendDraftReport
      reportId={reportId}
      draftTitle={draftTitle}
      sidebarToggle={() => {
        setSidebarState(!sidebarState);
        refetchGuestReports();
      }}
      {...props}
    />
  );

  useEffect(() => {
    if (sidebarState) {
      setSidebarWidth('1150px');
      setShowInSidebar(showSendList);
    } else {
      setShowInSidebar('');
      setSidebarWidth('0px');
    }
  }, [sidebarState]);

  const handleReportProperty = (value, title) => {
    setReportId(parseInt(value));
    setDraftTitle(title);
    setSidebarState(true);
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'Client Name',
        accessor: 'node.client.name',
        Cell: ({ value, row }) => <div>{value || row.original.node.clientName || row.original.node.name} {row.original.node.client ? row.original.node.client.discardedAt ? <Badge style={{backgroundColor: '#FEAC61'}} pill>Archived</Badge> : null : row.original.node.isDraft && <Badge style={{backgroundColor: '#FE9090'}} pill>Draft</Badge> }</div>,
      },
			{
        Header: 'Action',
        accessor: 'node.id',
        disableSortBy: true,
        Cell: ({ value, row }) => (
          <div>
            <UncontrolledButtonDropdown>
              <DropdownToggle color='link' className='bg-transparent border-0 shadow-none p-0 text-dark' aria-label='Action'>
                <Icon icon='ellipsis-v' />
              </DropdownToggle>
              <DropdownMenu>
                {
                  row.original.node.isDraft ?
                    <>
                      <DropdownItem onClick={() => handleReportProperty(value, row.original.node.title)}>
                        Edit
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem onClick={() => handleReportProperty(value, row.original.node.title)}>
                        Send Report
                      </DropdownItem>
                    </>
                  :
                    <DropdownItem onClick={() => resendMail(value)}>
                      Resend Email
                    </DropdownItem>
                }
                <DropdownItem divider />
                <DropdownItem onClick={() => handleSingleDelete(value)}>
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      },
      {
        Header: 'Title',
        accessor: 'node.title',
        Cell: ({ value, row }) => {
          const [title, setTitle] = useState(value || '');
          useEffect(() => {
            setTitle(value || '');
          }, [value, row]);
          const handleTitleChange = (e) => {
            setTitle(e.target.value);
          };
          const handleTitleBlur = () => {
            if (title.trim() === '') {
              toast.error('Title is required');
              setTitle(value || '');
            } else {
              handleTitleInput(title, row.original.node.id);
            }
          };
          return (
            <input
              type="text"
              value={title}
              onChange={handleTitleChange}
              onBlur={handleTitleBlur}
              style={{ width: '100%', border: 'none', borderRadius: '6px', padding: '4px', outline: 'none' }}
            />
          );
        },
      },
      {
        Header: 'URL',
        accessor: 'node.reportCode',
        Cell: ({ value, row }) => (
          <div>
            {value ? (
              <a
                target='_blank'
                href={config.url.WEB_DOMAIN + 'recommendations?code=' + value}
              >
                Click here
              </a>
            ) : (
              '-'
            )}
          </div>
        ),
      },
      {
        Header: 'Updated At',
        accessor: 'node.updatedAt',
        Cell: ({ value, row }) => (
          <div>{value ? formatTimeStamp(value) : '-'}</div>
        ),
      },
    ],
    []
  );
  const totalRecord = reports.length;

  const pageSizeOptions = React.useMemo(
    () => [
      { value: '10', label: '10' },
      { value: '15', label: '15' },
      { value: '25', label: '25' },
      { value: '50', label: '50' },
      { value: '75', label: '75' },
      { value: '100', label: '100' },
      { value: totalRecord.toString(), label: 'All' },
    ],
    [totalRecord]
  );

  const defaultColumn = React.useMemo(
    () => ({
      width: 'auto',
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    selectedFlatRows,
    rows: fullRows,
    state: { pageIndex, globalFilter, sortBy },
    prepareRow,
  } = useTable(
    {
      columns,
      data: reports,
      defaultColumn,
      initialState: { pageIndex: 0 },
      autoResetPage: false,
      autoResetExpanded: false,
      autoResetGroupBy: false,
      autoResetSelectedRows: false,
      autoResetSortBy: false,
      autoResetFilters: false,
      autoResetRowState: false,
      autoResetGlobalFilter: false,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((cols) => [
        {
          id: 'selection',
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
          ),
          Cell: ({ row }) => (
            <IndeterminateCheckbox
              {...row.getToggleRowSelectedProps()}
              onClick={(e) => e.stopPropagation()}
            />
          ),
          width: 50,
          maxWidth: 50,
        },
        ...cols,
      ]);
    }
  );

  useEffect(() => {
    setIsChecked(selectedFlatRows);
  }, [selectedFlatRows]);

  const onAllDeletePopup = () => {
    if (isCheckedId.length > 0) {
      setAllDeleteModal(!allDeleteModal);
    }
  };

  const deleteButton = (
    <Button
      color='red'
      onClick={onAllDeletePopup}
      disabled={isCheckedId.length === 0}
      className='button-dashboard float-right mr-2 mt-sm-0'
    >
      <Icon icon='trash-alt' className='mr-2' />
      Delete
    </Button>
  );

  const listCountLabel = `${fullRows.length} List${fullRows.length === 1 ? '' : 's'}`;

  const sortColumnLabel = React.useMemo(() => {
    if (!sortBy || sortBy.length === 0) {
      return 'Default Order';
    }
    const flatHeaders = headerGroups.flatMap((group) => group.headers);
    const match = flatHeaders.find((col) => col.id === sortBy[0].id);
    if (!match) return 'Custom';
    const headerValue = match.Header;
    if (typeof headerValue === 'string') {
      return headerValue;
    }
    if (typeof headerValue === 'function') {
      return 'Custom';
    }
    if (React.isValidElement(headerValue)) {
      return 'Custom';
    }
    return `${match.id}`.replace(/_/g, ' ');
  }, [sortBy, headerGroups]);

  const shouldShowBottomSpace = true;

  const formatTimeStamp = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    return new Intl.DateTimeFormat('default', options).format(
      Date.parse(dateString)
    );
  };

  return (
    <>
      {reportsLoading && <Spinner />}
      <SidebarRight
        sidebarState={sidebarState}
        sidebarToggle={() => {
          setSidebarState(!sidebarState);
        }}
        sidebarContent={showInSidebar}
        sidebarWidth={sidebarWidth}
        sidebarButton={false}
      />
      <Modal isOpen={resendModal} toggle={onResendPopup} centered>
        <ModalHeader toggle={onResendPopup}>Confirm Resend</ModalHeader>
        <ModalBody>Are you sure you want to resend this List?</ModalBody>
        <ModalFooter>
          <Button
            color='success'
            disabled={isProgress}
            onClick={handleResendMail}
          >
            Yes
          </Button>
          <Button color='primary' onClick={onResendPopup}>
            No
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={allDeleteModal} toggle={onAllDeletePopup} centered>
        <ModalHeader toggle={onAllDeletePopup}>Delete Confirmation</ModalHeader>
        <ModalBody>
          Are you sure you want to delete {isCheckedId.length} recommendation
          {isCheckedId.length > 1 ? 's' : ''}?
        </ModalBody>
        <ModalFooter>
          <Button
            color='danger'
            disabled={isProgress}
            onClick={handleDeleteAll}
          >
            Yes
          </Button>
          <Button color='success' onClick={onAllDeletePopup}>
            No
          </Button>
        </ModalFooter>
      </Modal>
      <Row className='mt-md-4'>
        <Col md='12'>
          {data === 'data' ? (
            <>
              <div className='d-none d-sm-block'>
                <Row className='my-2 d-flex align-items-start'>
                  <Col sm='6'>
                    <GlobalFilter
                      preGlobalFilteredRows={preGlobalFilteredRows}
                      globalFilter={globalFilter}
                      setGlobalFilter={setGlobalFilter}
                    />
                  </Col>
                  <Col sm='6' className='text-lg-right'>
                    {deleteButton}
                  </Col>
                </Row>

                <Table
                  responsive
                  className='client-list text-left min-w-900'
                  {...getTableProps()}
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps([
                              {
                                style: {
                                  minWidth: column.minWidth,
                                  width: column.width,
                                  maxWidth: column.maxWidth,
                                },
                              },
                              column.getSortByToggleProps(),
                            ])}
                          >
                            {column.render('Header')}
                            <span>
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <>
                                    &nbsp; <Icon icon='sort-down' size='lg' />
                                  </>
                                ) : (
                                  <>
                                    &nbsp; <Icon icon='sort-up' size='lg' />
                                  </>
                                )
                              ) : column.canSort ? (
                                <>
                                  &nbsp; <Icon icon='sort' size='lg' />
                                </>
                              ) : (
                                ''
                              )}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                          ))}
                        </tr>
                      );
                    })}
                    {page.length <= 2 ? (
                      <tr>
                        <div className='spacer-div'></div>
                      </tr>
                    ) : null}
                    {shouldShowBottomSpace ? (
                      <tr>
                        <div className='rtable-bottom-space'></div>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>
              </div>

              <div className='d-block d-sm-none'>
                <div style={mobileStyles.filterContainer}>
                  <div style={mobileStyles.filterHeader}>
                    <div onClick={(e) => e.stopPropagation()}>
                      <GlobalFilter
                        preGlobalFilteredRows={preGlobalFilteredRows}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                      />
                    </div>
                    <div style={mobileStyles.filterRow}>
                      <span style={mobileStyles.filterLabel}>{listCountLabel}</span>
                      <span>Sort By: {sortColumnLabel}</span>
                    </div>
                  </div>
                  <div style={mobileStyles.mobileActionsWrapper}>
                    {React.cloneElement(deleteButton, {
                      className: 'mobile-action-btn',
                      style: {
                        ...mobileStyles.actionButton,
                        ...(deleteButton.props.style || {}),
                      },
                    })}
                  </div>
                </div>

                <div style={mobileStyles.listWrapper}>
                  {page.map((row) => {
                    prepareRow(row);
                    const node = row.original?.node || {};
                    const client = node.client || {};
                    const clientName =
                      client.name || node.clientName || node.name || 'Untitled List';
                    const listTitle = node.title || 'Untitled List';
                    const listLink = node.reportCode
                      ? `${config.url.WEB_DOMAIN}recommendations?code=${node.reportCode}`
                      : null;
                    const isDraft = !!node.isDraft;
                    const isArchived = !!client.discardedAt;
                    const updatedAt = node.updatedAt;
                    const timeAgo = formatRelativeTime(updatedAt);
                    const selectionProps = row.getToggleRowSelectedProps();

                    const badgeStyle = {
                      ...mobileStyles.badge,
                      background: isArchived
                        ? 'rgba(241, 81, 69, 0.15)'
                        : 'rgba(37, 198, 142, 0.15)',
                      color: isArchived ? '#c2410c' : isDraft ? '#f97316' : '#059669',
                    };

                    const summaryLines = [];
                    if (isDraft) {
                      summaryLines.push('Draft list not yet sent');
                    } else {
                      summaryLines.push('Shared recommendation list');
                    }
                    if (node.hidePropertyName) {
                      summaryLines.push('Property names hidden');
                    }

                    return (
                      <div key={row.id} style={mobileStyles.card}>
                        <div style={mobileStyles.headerRow}>
                          <div style={mobileStyles.headerLeft}>
                            <div style={mobileStyles.nameRow}>
                              <div
                                onClick={(e) => e.stopPropagation()}
                              >
                                <IndeterminateCheckbox {...selectionProps} />
                              </div>
                              <span style={mobileStyles.primaryName}>{clientName}</span>
                              {(isDraft || isArchived) && (
                                <span style={badgeStyle}>
                                  {isArchived ? 'Archived' : 'Draft'}
                                </span>
                              )}
                            </div>
                            <div style={mobileStyles.subtitle}>{listTitle}</div>
                          </div>
                          <div>
                            <span style={mobileStyles.timeAgo}>
                              {timeAgo ? timeAgo : ''}
                            </span>
                          </div>
                        </div>

                        <div style={mobileStyles.detailSection}>
                          {summaryLines.map((line) => (
                            <div key={line} style={mobileStyles.detailText}>
                              {line}
                            </div>
                          ))}
                          <div style={mobileStyles.detailText}>
                            Updated {formatTimeStamp(updatedAt)}
                          </div>
                          {listLink ? (
                            <div>
                              <a
                                href={listLink}
                                target='_blank'
                                rel='noopener noreferrer'
                                style={mobileStyles.linkText}
                                onClick={(e) => e.stopPropagation()}
                              >
                                View List
                              </a>
                            </div>
                          ) : null}
                        </div>

                        <div style={mobileStyles.actionRow}>
                          {isDraft ? (
                            <>
                              <Button
                                color='primary'
                                style={mobileStyles.primaryButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleReportProperty(node.id, node.title);
                                }}
                              >
                                Send Report
                              </Button>
                              <Button
                                color='secondary'
                                style={mobileStyles.secondaryButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleReportProperty(node.id, node.title);
                                }}
                              >
                                Edit Draft
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                color='primary'
                                style={mobileStyles.primaryButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (listLink) {
                                    window.open(listLink, '_blank');
                                  }
                                }}
                                disabled={!listLink}
                              >
                                View List
                              </Button>
                              <Button
                                color='secondary'
                                style={mobileStyles.secondaryButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  resendMail(node.id);
                                }}
                              >
                                Resend Email
                              </Button>
                            </>
                          )}
                          <Button
                            color='danger'
                            style={mobileStyles.secondaryButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSingleDelete(node.id);
                            }}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <Row className='d-flex align-items-center mt-4'>
                <Col md='6'>
                  <FormGroup className='mb-3 mb-md-0'>
                    <Label
                      for='report-page-size'
                      className='mb-0 w-auto d-inline-block mr-2 mr-md-3'
                    >
                      Showing Entries
                    </Label>
                    <Select
                      inputId='report-page-size'
                      name='PageSize'
                      defaultValue={pageSizeOptions[0]}
                      options={pageSizeOptions}
                      onChange={(e) => {
                        setPageSize(Number(e.value));
                      }}
                      className='basic-multi-select text-left'
                      classNamePrefix='default-select'
                      menuPlacement='auto'
                    />
                  </FormGroup>
                </Col>

                <div className='justify-content-center'>
                  <ul className='pagination'>
                    <li onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                      <a>
                        <Icon icon='chevron-left' />
                        <Icon icon='chevron-left' />
                      </a>
                    </li>
                    <li onClick={() => previousPage()} disabled={!canPreviousPage}>
                      <a>
                        <Icon icon='chevron-left' />
                      </a>
                    </li>
                    <span className='d-flex align-items-center px-3'>
                      Page &nbsp; <strong>{pageIndex + 1}</strong> &nbsp; of &nbsp;
                      <strong>{pageOptions.length}</strong>
                    </span>
                    <li onClick={() => nextPage()} disabled={!canNextPage}>
                      <a>
                        <Icon icon='chevron-right' />
                      </a>
                    </li>
                    <li onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                      <a>
                        <Icon icon='chevron-right' />
                        <Icon icon='chevron-right' />
                      </a>
                    </li>
                  </ul>
                </div>
              </Row>
            </>
          ) : (
            <>
              {data === 'noData' ? (
                <div className='text-center' style={{ margin: '35vh 0' }}>
                  <h4>
                    You haven't sent property recommendations to any clients.
                  </h4>
                  <Button
                    onClick={() => history.push('/properties')}
                    color='success'
                    className='button-dashboard mt-2'
                  >
                    Send property recommendations to a client now{' '}
                    <Icon icon='chevron-right' className='ml-2' />
                  </Button>
                </div>
              ) : null}
            </>
          )}
        </Col>
      </Row>
    </>
  );
}
